import moment from 'moment'
import { date } from 'quasar'

export default ({ app, Vue }) => {
  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })

  Vue.filter('uppercase', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.toUpperCase()
  })

  Vue.filter('truncate', function (string, value) {
    if (string.length > value) {
      return string.substring(0, value) + '…'
    }
    return string
  })

  Vue.filter('monthYear', function (value) {
    if (value) {
      return date.formatDate(moment(String(value), 'YYYY-MM-DD'), 'MMMM YYYY', {
        months: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
      })
    }
  })
}
